import createNamespaceContext from './helper/createNamespaceContext';
export const GROWTH_CONTEXT = 'editionAwarenessCtx';
export const GrowthAnalyticsContext = createNamespaceContext(GROWTH_CONTEXT, 'GrowthAnalyticsContext');